import React from 'react';
import PropTypes from "prop-types";
import nl2br from 'react-nl2br';
import apiSettings from "../../../config/api";
import apiConsts from '../../../config/const';
import {round} from "../../../utils/func";

const TourBlock = (props) => {
  const {
    id,
    title,
    priceOnePerson,
    tourPhotos,
    description,
    getTourById,
  } = props;

  const getPhotoUrl = () => {
    if (tourPhotos && tourPhotos[0] && tourPhotos[0][apiConsts.PHOTOS.extraSmall]) {
      return apiSettings.endpoints.genImageUrl(tourPhotos[0][apiConsts.PHOTOS.extraSmall], tourPhotos[0].updatedAt);
    }
    return '/assets/img/noimage.png';
  };

  return (
    <div
      className="tour__item"
      onClick={() => getTourById(id)}
      role="presentation"
      onKeyDown={() => {
      }}
    >
      <div className="tour__item-img">
        <img
          src={getPhotoUrl()}
          alt="title"
          onError={(e) => {
            e.target.src = '/assets/img/noimage.png'
          }}
        />
      </div>
      <div className="tour__block-group">
        <h3 className="tour__item-title">{title}</h3>
        <p className="tour__item-description">{nl2br(description)}</p>
      </div>
      <div className="tour__item-value">
        <p className="tour__item-price">
          <span>$</span>
          {round(priceOnePerson, 2)}
        </p>
        <p className="tour__item-person">person</p>
      </div>
      <p className="read-more">Read more ...</p>
    </div>
  )
};

TourBlock.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  description: PropTypes.string,
  priceOnePerson: PropTypes.number,
  tourPhotos: PropTypes.array,
  getTourById: PropTypes.func,
};

export default TourBlock;


// WEBPACK FOOTER //
// ./src/app/containers/SearchResult/components/TourBlock.js